import LoadingImage from "/assets/img/loading-bicycle.gif";

import './unable-to-fix-request.modal.scss';

export default function UnableToFixRequestModal($scope, onUpload, close, $file, $alert, $t) {
  'ngInject';

  $scope.unableToFix = {
    type: 'SKILLS',
    description: '',
    images: [],
    types: [
      'SKILLS',
      'CANT_ACCESS_LOCATION',
      'MISSING_EQUIPMENT',
      'EQUIPMENT_PROBLEM',
      'SAFETY_ISSUE',
      'OTHER'
    ],
    hideFirst: false,
    size: 's'
  };

  $scope.chooseFile = (files, invalidFiles) => {
    if (!files || files.length === 0) {
      return;
    }

    const filesToUpload = [];
    files.filter(file => $file.isValidFile(file))
      .forEach(file => filesToUpload.push(file));
    invalidFiles.filter(file => $file.isValidFile(file))
      .forEach(file => filesToUpload.push(file));
    if (filesToUpload.length === 0) {
      return;
    }

    filesToUpload.forEach(file => {
      const img = {
        id: file.name,
        thumbnail: LoadingImage,
        original: file,
        uploading: true,
        error: true
      }

      $scope.unableToFix.images.push(img);
      $scope.unableToFix.upload($scope.unableToFix.images.length - 1)
    })

    $scope.unableToFix.recalculate();
  };

  $scope.unableToFix.upload = index => {
    const img = $scope.unableToFix.images[index];
    img.uploading = true;
    img.error = false;

    onUpload(img.original,
      response => {
        for (let i = 0; i < $scope.unableToFix.images.length; i++) {
          if ($scope.unableToFix.images[i].id === img.id) {
            $scope.unableToFix.images[i] = response;
            break;
          }
        }
      },
      error => {
        img.error = true;
        img.uploading = false;
        $alert.processError(error, $t('shared.modals.photos.upload_image_error'))
      }
    );
  }

  $scope.unableToFix.remove = (index) => {
    if (index > -1 && index < $scope.unableToFix.images.length) {
      $scope.unableToFix.images.splice(index, 1)
    }
  }

  $scope.ok = (form) => {
    if (form.$valid) {
      const result = {
        images: $scope.unableToFix.images
      };

      if ($scope.unableToFix.type !== 'SKILLS') {
        result.description = $scope.unableToFix.description;
      }

      close(result);
    }
  };

  $scope.close = () => {
    close();
  };

}